import { MdArrowForwardIos } from "react-icons/md";
import iconT from "../../../assests/solutionImages/SocialMedia/iconTwitter.svg";
import iconF from "../../../assests/solutionImages/SocialMedia/iconFaceBook.svg";
import iconL from "../../../assests/solutionImages/SocialMedia/iconlinkdin.svg";
// import iconReddit from "../../../assests/solutionImages/SocialMedia/iconReddit.svg"; // Add this if available
import bgimgMultiurl from "../../../assests/solutionImages/SocialMedia/Bgthemeimg.svg";

function SocialmediaTheme({ card }) {
  console.log(card);

  // Platform icon mapping
  const getPlatformIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case 'facebook':
        return iconF;
      case 'twitter':
        return iconT;
      case 'linkedin':
        return iconL;
      // case 'reddit':
      //   return iconReddit; // You'll need to add this icon
      default:
        return iconF; // Default fallback
    }
  };

  // Platform name formatting
  const formatPlatformName = (platform) => {
    return platform.charAt(0).toUpperCase() + platform.slice(1).toLowerCase();
  };

  return (
    <div className="flex md:py-4 p-2 justify-center min-h-screen bg-gray-200">
    <div className="relative max-w-[393px] overflow-y-auto scrollbar-hide bg-white rounded-xl shadow-lg mx-auto">

  {/* Cover Image */}
  <div className="relative">
    <img
      src={card?.backgroundImage || bgimgMultiurl}
      alt="Cover"
      className="w-full h-48 object-cover"
    />

    {/* Profile Image (overlapping bottom of cover) */}
    {(card?.profileImage && card?.data?.isProfileVisible) && (
      <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2 rounded-full overflow-hidden w-36 h-36  bg-white">
        <img
          src={card.profileImage}
          alt="Profile"
          className="w-full h-full object-cover"
        />
      </div>
    )}

    {/* Optional: fallback image */}
    {/* {!card?.profileImage && (
      <div className="absolute -bottom-12 left-1/2 transform -translate-x-1/2 rounded-full w-36 h-36 overflow-hidden border-4 border-white bg-white">
        <img
          src={DefaultProfile}
          alt="Default Profile"
          className="w-full h-full object-cover"
        />
      </div>
    )} */}
  </div>

  {/* Text Section */}
  <div
    className={`text-center ${
      card?.profileImage && card?.data?.isProfileVisible ? 'pt-20' : 'pt-6'
    } px-4 max-w-[306px] mx-auto`}
  >
    <h2 className="text-2xl font-bold text-[#000000] break-words">
      {card?.data?.headline || 'Social Media Headline'}
    </h2>
    <p className="text-[#555555] break-words">
      {card?.data?.summary ||
        'Follow us and get updates delivered to your favorite social media channel.'}
    </p>
  </div>

  {/* Social Media Links */}
  <div className="grid grid-cols-1 gap-2 px-4 py-6">
    {card?.data?.socialMediaLinks?.map((link, index) => (
      <div
        key={index}
        className="bg-[#232323] rounded-xl py-4 cursor-pointer hover:bg-[#2a2a2a] transition-colors"
        onClick={() => window.open(link.url, '_blank')}
      >
        <div className="flex justify-between items-center gap-2 px-4">
          <div className="flex items-center gap-2">
            <img
              src={getPlatformIcon(link.platform)}
              alt={`${link.platform} Icon`}
              className="w-6 h-6"
            />
            <div>
              <p className="text-sm text-[#CCCCCC] break-words">{link.title}</p>
              <p className="text-lg font-medium text-white break-words">
                {formatPlatformName(link.platform)}
              </p>
            </div>
          </div>
          <MdArrowForwardIos className="text-white" />
        </div>
      </div>
    ))}
  </div>
</div>

    </div>
  );
}

export default SocialmediaTheme;
